import { store } from '@/redux/lib/configureStore.js';

const dispatchHelper = (action, dispatch = store.dispatch) => {
  return (response, ...additionalArgs) => {
    if (response === undefined) {
      return;
    }

    const callbacks = additionalArgs.filter((value) => typeof value === 'function');
    const meta = additionalArgs.find((value) => value && typeof value === 'object' && !Array.isArray(value));

    const handle = ({ type = action, payload, error, middleware = {} } = {}) => {
      const nextPayload = payload && typeof payload === 'object' && meta ? { ...payload, meta: { ...meta, ...(payload.meta || {}) } } : payload;

      if (type) {
        dispatch({
          type: error ? `${type}_FAIL` : `${type}_SUCCESS`,
          payload: nextPayload,
          ...middleware
        });
      }

      callbacks.forEach((callback) => {
        const data = error ? undefined : (nextPayload || {}).data || nextPayload;
        const err = error ? nextPayload : undefined;
        callback(null, data, err);
      });
    };

    if (Array.isArray(response)) {
      const isSuccess = response.every((item) => item?.status === 200);

      if (isSuccess) {
        handle({
          payload: response
        });
      }

      return;
    }

    if (!response?.status) {
      handle({
        payload: response?.data || response,
        error: 'No response status'
      });
      return;
    }

    if (response.status >= 400 || response?.data?.success === false) {
      handle({
        payload: response?.data,
        error: 'Request failed'
      });
      return;
    }

    handle({
      payload: response?.data,
      middleware: response?.middleware || {}
    });
  };
};

export default dispatchHelper;
